import NutritionCharts from '../../components/nutrition/NutritionCharts';
import ErrorMessage from '../../components/ui/ErrorMessage';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import { useModalNavigation, useModalPayload } from '../../context/ModalControllerContext';
import { useModalEntry } from '../../context/ModalEntryContext';
import useGetNutritionByMeal from '../../hooks/data/nutrition/useGetNutritionByMeal';
import ModalHeader from '../components/ModalHeader';

const ModalMealNutrition = () => {
    const { selectedEntryId, selectedEntry } = useModalEntry();

    const payload = useModalPayload();

    const { close, canGoBack, goBack } = useModalNavigation();

    // RESOLVE SOURCE

    const mealId = !payload ? selectedEntryId : null;
    const favoriteId = payload?.isFavorite ? payload.id : null;
    const recipeId = payload?.isRecipe ? payload.id : null;

    const items = payload?.items ?? selectedEntry?.items ?? [];
    const mealName = payload?.name || selectedEntry?.name || 'Måltidsinformation';

    // DATA

    const { data, isLoading, isError, error } = useGetNutritionByMeal({
        mealId,
        favoriteId,
        recipeId
    });

    if (isLoading) return <LoadingSpinner />;

    if (isError)
        return <ErrorMessage message={error?.message || 'Kunde inte hämta näringsinformation just nu.'} />;

    return (
        <>
            <ModalHeader title={mealName} onClose={close} onGoBack={goBack} showBack={canGoBack} />

            <div className="modal-body meal-nutrition">
                <NutritionCharts data={data} items={items} showMacros />
            </div>
        </>
    );
};

export default ModalMealNutrition;
